export function getErrorMessage(error, fallback) {
    const data = error?.response?.data;
    const errorsMap = data?.errors || data?.Errors;
    if (errorsMap) {
        const primeiraMensagem = Object.values(errorsMap).flat()[0];
        if (primeiraMensagem) return primeiraMensagem;
    }
    return data?.message || data?.Message || fallback;
}
